import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import { HeadlineNumber } from '../../../components/UI/HeadlineNumber';
import { PropertyChartLine } from './PropertyChartLine';

export class PurchasePropertyPanel extends Component {
    render() {
        var personallyHeldYears = Math.round((this.props.profitGoal / (this.props.incomePersonal + this.props.additionalAnnualInvestment)) * 10) / 10;
        var companyHeldYears = Math.round((this.props.profitGoal / (this.props.incomeSPV + this.props.additionalAnnualInvestment)) * 10) / 10;

        return (
            <Card className="panel-card">
                <CardBody>
                    <Row>
                        <Col xs="12" className="chart-container" data-testid="purchasePropertyPanel">
                            <PropertyChartLine
                                spv={this.props.incomeSPV}
                                personal={this.props.incomePersonal}
                                additionalAnnualInvestment={this.props.additionalAnnualInvestment}
                                field='retainedTotal'
                                target={this.props.profitGoal}
                                /*If infinity, use 30 (arbitrary) to avoid an infinite loop during chart rendering*/
                                yearsToGoal={personallyHeldYears < Infinity && companyHeldYears < Infinity ? Math.max(personallyHeldYears, companyHeldYears) + 1 : 30}
                            />
                        </Col>
                    </Row>
                    <Row className="above-chart">
                        {companyHeldYears >= 0 &&
                            <Col xs={personallyHeldYears >= 0 ? "6" : "12"}>
                                <HeadlineNumber
                                    title="Company held"
                                    value={companyHeldYears + ' years'}
                                    description='To buy next property'
                                />
                            </Col>
                        }
                        {personallyHeldYears >= 0 &&
                            <Col xs={companyHeldYears >= 0 ? "6" : "12"}>
                                <HeadlineNumber
                                    title="Personally held"
                                    value={personallyHeldYears + ' years'}
                                    description='To buy next property'
                                />
                            </Col>
                        }
                    </Row>

                </CardBody>
            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/PurchasePropertyPanel.jsx